export function atualizarEmissorNoXML(xmlString, cliente) {
  try {
    const parser = new DOMParser();
    const xml = parser.parseFromString(xmlString, 'application/xml');

    if (xml.getElementsByTagName('parsererror').length > 0) {
      console.error('Erro ao parsear XML original.');
      return xmlString;
    }

    const emit = xml.getElementsByTagName('emit')[0];
    if (emit && cliente) {
      const setTagValue = (tagName, value) => {
        const tag = emit.getElementsByTagName(tagName)[0];
        if (tag) tag.textContent = value;
      };

      setTagValue('CNPJ', cliente.cnpjCpf);
      setTagValue('xNome', cliente.nomeFantasia);

      const enderEmit = emit.getElementsByTagName('enderEmit')[0];
      if (enderEmit && cliente.endereco) {
        const endereco = cliente.endereco;

        setTagValue('xLgr', endereco.logradouro || '');
        setTagValue('nro', endereco.numero || '');
        setTagValue('xBairro', endereco.bairro || '');
        setTagValue('xMun', endereco.cidade || '');
        setTagValue('UF', endereco.uf || '');
        setTagValue('CEP', (endereco.cep || '').replace(/\D/g, ''));
      }
    }

    const serializer = new XMLSerializer();
    const xmlComHeader =
      '<?xml version="1.0" encoding="UTF-8"?>\n' +
      serializer.serializeToString(xml.documentElement);

    return xmlComHeader;
  } catch (err) {
    console.error('Erro ao atualizar emissor no XML', err);
    return xmlString;
  }
}
